export default {
  text: 'Harta este furnizată de Google. Încărcarea ei trimite adresa ta IP către Google.',
  buttons: {
    show_map: 'Afișează harta',
    retry: 'Încearcă din nou',
  },
  errors: {
    map_unavailable: 'Harta nu a putut fi încărcată.',
  },
};
